import axios from "axios";
import { Link, useNavigate } from 'react-router-dom';
import React, { useCallback, useEffect, useRef, useState } from 'react';

export default (props) => {
  const cellValue = props.valueFormatted ? props.valueFormatted : props.value;

  // const deleteClicked = () => {
  //   alert(`${cellValue} deleted`);
  // };

  const navigate = useNavigate();
  const baseURL = "https://nseapi.maclogi.com/api/";
  //const baseURL = "http://localhost:3000/api/";
  const editClicked = () => {
    navigate('/editnse/' + cellValue);
  };

  const deleteClicked = () => {
    axios.delete(baseURL + "nses/" + cellValue).then((response) => {
      alert("NSE record " + cellValue + " deleted!");
      window.location.reload();
    }).catch(error => {
      alert("Error Ocurred in removeNSE:" + error);
    });
  }


  return (
    <span>
      <span>{cellValue}</span>&nbsp;
      <button onClick={() => editClicked()}>Edit</button>
      &nbsp;&nbsp;
      <button onClick={() => deleteClicked()}>Delete</button>
    </span>
  );
};